import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import WebApiRoutes from '@config/Routes/WebApiRoutes';
import WebApiGeneralRoutes from '@config/Routes/WebApiGeneralRoutes';

const baseQuery = fetchBaseQuery({
  baseUrl: WebApiRoutes.getBaseUrl(),
});

const InvoiceSeatAdjustmentApi = createApi({
  reducerPath: 'invoiceSeatAdjustmentApi',
  baseQuery,
  endpoints: (builder) => ({
    invoiceSeatAdjustmentCommand: builder.mutation({
      query: ({ parameters, accessToken }) => ({
        url: WebApiGeneralRoutes.apiV1Path('/seat-adjustments-command'),
        method: 'POST',
        body: parameters,
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),
    invoiceSeatAdjustmentList: builder.mutation({
      query: ({ accessToken, resellerId, pageNumber, pageSize, filters }) => {
        return {
          url: WebApiGeneralRoutes.apiV1Path(`/seat-adjustments-list`, {
            resellerId,
            pageNumber,
            pageSize,
          }),
          method: 'POST',
          headers: { Authorization: `Bearer ${accessToken}` },
          body: {
            filters: [
              {
                field: 'filter_year',
                value: filters.year || '0',
              },
              {
                field: 'filter_month',
                value: filters.month || '0',
              },
            ],
          },
        };
      },
    }),
  }),
});

export const { useInvoiceSeatAdjustmentCommandMutation, useInvoiceSeatAdjustmentListMutation } =
  InvoiceSeatAdjustmentApi;

export default InvoiceSeatAdjustmentApi;
